import { useContext } from "react"
import { SidebarContext, type SidebarContextProps } from "@shadcn/components/layouts/Sidebar/Sidebar"

/**
 * Safe version of useSidebar that returns null instead of throwing
 * when used outside of a SidebarProvider context.
 *
 * This allows components to gracefully handle the absence of sidebar context
 * without violating React's Rules of Hooks.
 *
 * @returns SidebarContextProps | null - The sidebar context or null if not within a provider
 */
export function useSidebarSafe(): SidebarContextProps | null {
	return useContext(SidebarContext)
}
